
import NuxtImage from '~/components/Modules/Common/NuxtImage'

export default {
  components: { NuxtImage },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
